import OAuth2RequestsIcon from '@material-ui/icons/TrackChanges';

import { OAuth2RequestsList } from './List/List';


export {
	OAuth2RequestsList,
};

export const oAuth2RequestsResource = {
	list: OAuth2RequestsList,
	icon: OAuth2RequestsIcon,
};
